export default {
  phone: '',
  phoneOperator: '',
  name: '',
  remarks: '',
  usingStatus: '',
  loginUrl: '',
  hasSubsidiary: null,
  platformKey: '',
  regType: '',
  companyName: '',
  legalPerson: '',
  hasShop: 0,
  showType:1,
  mainAccount: {
    account: '',
    password: '',
    wechat: null,
    wechatOwner: '',  // 新增字段
    phone: null,
    phoneOwner: '',   // 新增字段
    qq: null,
    qqOwner: '',      // 新增字段
    email: null,
    emailOwner: '',   // 新增字段
    hasId: 1,
    passwordEye: false,
    passwordChanged: false,
    passwordLooked : false,
    accountIdList: [
      {
        accountId: "",      // 账号ID
        categoryId: null,   // 所属五域类目
        channelName: "",    // 渠道号
        status: ""          // ID使用状态
      }
    ],
    usingUserList: [],
    usingUserIdList: []
  },
  subAccountList: [
    {
      account: '',
      password: '',
      wechat: null,
      wechatOwner: '',  // 新增字段
      phone: null,
      phoneOwner: '',   // 新增字段
      qq: null,
      qqOwner: '',      // 新增字段
      email: null,
      emailOwner: '',   // 新增字段
      hasId: 1,
      passwordEye: false,
      passwordChanged: false,
      passwordLooked : false,
      accountIdList: [
        {
          accountId: "",      // 账号ID
          categoryId: null,   // 所属五域类目
          channelName: "",    // 渠道号
          status: ""          // ID使用状态
        }
      ],
      usingUserList: [],
      usingUserIdList: []
    }
  ],
  shopList: [
    {
      shopName: '',
      shopId: '',
      status: ''
    }
  ],
}